/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as utilService from '../services/utilService'
import * as eventService from '../services/eventService'
import * as stringParser from '../util/string.util'
import * as dateUtil from '../util/date.util'
import Joinnowpopup from './sub_components/joinnowpopup'
import Loginpopup from './sub_components/loginpopup'
import LoginSportsThumbnailList from './sub_components/loginSportsThumbnailList'
import AboutUs from './sub_components/aboutUs'
import BettingRules from './sub_components/bettingRules'
import DepositsAndWithdrawals from './sub_components/depositsAndWithdrawals'
import PrivacyPolicy from './sub_components/privacyPolicy'
import TermsAndConditions from './sub_components/termsAndConditions'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import { SOCIALMEDIALINKS } from '../configs/apkFileName';
import UnderMaintenance from './under_maintenance';
import {BRANDLOGOFILENAME} from '../configs/authSignupConfig';
import {showAdminBannerLink, showBHMBannerLink} from '../configs/casinoShowList';

// import bannerList from 'https://images.staticcontents.com/banners/list.json'

 let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class Auth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            inMaitanenceMessage: '',
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection : "",
            clientWidth: document.documentElement.clientWidth,
            affCode:""
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    componentWillMount() {
        utilService.checkMaintainanceCall().then((res) => {
            if (res.isSuccess && !!res.items && res.items.isMaintenance) {
                this.setState({
                    inMaitanence: true,
                    inMaitanenceMessage: res.items
                })
            }
        })
    }

    async componentDidMount() {
        const { match: { params } } = this.props;
        if(window.location.pathname.indexOf('/affiliate')>-1){
            this.setState({affCode: params.affCode})
        }
        localStorage.removeItem('videoSplashScreenVisited');
        localStorage.removeItem("homeData")
        localStorage.removeItem("userAuthDetail")
        localStorage.removeItem("tokenData")
        if (constants.isDev) {
            this.setState({ isDev: true })
        }
        let savedData = localStorage.getItem("rememberData")
        if (!!savedData) {
            savedData = JSON.parse(savedData)
            if (!!savedData && !!savedData.uid) {
                this.setState({ rememberMe: true, uid: savedData.uid, passcode: !!savedData.passcode ? savedData.passcode : "" })
            }
        }
        if (!window.location.href.includes("apk")) {
            this.setState({ showDownLoad: true })
            localStorage.setItem("appType", "web")
        } else {
            localStorage.setItem("appType", "mobile")
        }
        
        eventService.getBaseHomeData().then((res) => {
            let homeData = this.parseBook(res)
            localStorage.setItem('homeData', JSON.stringify(homeData))
            localStorage.setItem('isBaseData', "true")
        })
        
        // headers.append('Referrer-Policy', 'origin');
        // options.referrerPolicy = 'no-referrer-when-downgrade'; Referrer-Policy "origin"
        // headers.append('Accept', '*/*');
        // headers.append('Access-Encoding', 'gzip, deflate, br');
        // headers.append('Connection', 'keep-alive');
        var options = {};
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin', '*');
        options.headers = headers;

        

        
        // let banners = await utilService.getBanner()
        // let banners = await utilService.getBannerListJson()
        // debugger
        // utilService.getBannerListJson().then((res)=>{
        //     if(!!res){
        //         let desktop_banners_arr = res.desktop
        //         let mobile_banners_arr = res.mobile

        //         let desktop_banners = {}
        //         for (var banner of desktop_banners_arr) {
        //             desktop_banners[banner.split(".")[0]] = `https://images.staticcontents.com/banners/desktop_banner_${banner}`
        //         }

        //         let mobile_banners = {}
        //         for (var mobbanner of mobile_banners_arr) {
        //             mobile_banners[mobbanner.split(".")[0]] = `https://images.staticcontents.com/banners/mobile_banner_${mobbanner}`
        //         }

        //         this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        //     }
        // })
        if(showAdminBannerLink){
            utilService.getOperatorBannerListJson().then((res) => {
                if (!!res) {
                    let desktop_banners_arr = res.desktop
                    let mobile_banners_arr = res.mobile
    
                    let desktop_banners = {}
                    for (var banner of desktop_banners_arr) {
                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/desktop_banner_${banner}`
                    }
    
                    let mobile_banners = {}
                    for (var mobbanner of mobile_banners_arr) {
                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/mobile_banner_${mobbanner}`
                    }
                    
                    this.setState({ operatorDesktopBanners: desktop_banners, operatorMobileBanners: mobile_banners },()=>{
                        if(showBHMBannerLink){
                            utilService.getBannerListJson().then((res) => {
                                if (!!res) {
                                    let desktop_banners_arr = res.desktop
                                    let mobile_banners_arr = res.mobile
                                    
                                    let desktop_banners = {}
                                    for (var banner of desktop_banners_arr) {
                                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                                    }
                                    let mobile_banners = {}
                                    for (var mobbanner of mobile_banners_arr) {
                                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                                    }
                    
                                    this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                                }
                            })
                        }
                    })
                }
            })
        } else { 
            if(showBHMBannerLink){ 
                utilService.getBannerListJson().then((res) => {
                    if (!!res) {
                        let desktop_banners_arr = res.desktop
                        let mobile_banners_arr = res.mobile

                        let desktop_banners = {}
                        for (var banner of desktop_banners_arr) {
                            desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                        }

                        let mobile_banners = {}
                        for (var mobbanner of mobile_banners_arr) {
                            mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                        }

                        this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                    }
                })
            }
        }
        // if (!!banners.items && banners.items.length > 0 && banners.isSuccess) {

        //     let desktop_banners_arr = banners.items.filter((banner) => { return banner.includes("desktop_banner") })
        //     let mobile_banners_arr = banners.items.filter((banner) => { return banner.includes("mobile_banner") })

        //     let desktop_banners = {}
        //     for (var banner of desktop_banners_arr) {
        //         desktop_banners[banner.split("_")[2].split(".")[0]] = banner
        //     }

        //     let mobile_banners = {}
        //     for (var mobbanner of mobile_banners_arr) {
        //         mobile_banners[mobbanner.split("_")[2].split(".")[0]] = mobbanner
        //     }

        //     this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        // }
    }
    

    // showToast(msg, type) {
    //     let self = this
    //     this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
    //         setTimeout(() => {
    //             self.setState({ toastMsg: "", toastType: "", showToast: false })
    //         }, 3000);
    //     })
    // }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }

    handleKey(e) {
        if (e.keyCode === 13) {
            this.signIn();
        }
    }

    signIn() {
        let body = {
            "username": this.state.uid.trim().toLowerCase(),
            "password": this.state.passcode
        }
        if (!this.state.uid.trim()) {
            this.props.notify("Please Insert Username!", "error")
            return false
        }
        if (!this.state.passcode) {
            this.props.notify("Please Insert Password!", "error")
            return false
        }
        if (this.state.rememberMe) {
            let data = {
                "uid": this.state.uid.trim().toLowerCase(),
                "passcode": this.state.passcode
            }
            localStorage.setItem("rememberData", JSON.stringify(data))
        } else {
            localStorage.removeItem("rememberData")
        }
        authServices.signin(body).then(async (result) => {
            if (result.token) {
                let data = {
                    token: result.token
                }
                let accessControl = {
                    sports: true,
                    binary: true,
                    casino: true
                }
                localStorage.setItem("userAuthDetail", JSON.stringify(data))
                let velidateData = await authServices.velidateToken()

                if (!!velidateData.role && velidateData.role === "Client") {
                    localStorage.setItem("tokenData", JSON.stringify(velidateData))
                    localStorage.setItem("accessControl", JSON.stringify(accessControl))
                    let accData = await accountServices.getAccountData()
                    if(!!accData && !!accData.userLock && accData.userLock){
                        this.props.notify("User Is Locked. Please Contact Upperline!", "error")
                        this.logout()
                    }
                    localStorage.setItem("accountData", JSON.stringify(accData))
                    let configData = await authServices.getConfigButton()
                    localStorage.setItem("buttonsValues", JSON.stringify(configData))
                    if (velidateData.pwdch) {
                        this.props.history.push("/setpassword");
                    }
                    else {
                        // this.props.history.push("/home");
                        window.location.href = "/home"
                    }
                } else if (!!velidateData.role && velidateData.role !== "Client") {
                    this.props.notify(velidateData.role + " user is not allow to access this portal.", "error")
                } else {
                    this.props.notify(velidateData.exception.message, "error")
                }
            } else {
                this.props.notify(result.exception.message, "error")
            }
        })
    }

    logout() {
        let appType = localStorage.getItem("appType")
        let rememberData = localStorage.getItem("rememberData")
        localStorage.clear()
        localStorage.setItem("rememberData", rememberData)
        if (appType === "mobile") {
            window.location.href = window.location.origin + "/apk";
        } else {
            window.location.href = window.location.origin + "/auth";
        }
    }

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]:false })
        
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    parseBook(data) {
        !!data && data.length > 0 && data.forEach((mkt, i) => {
            // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
            let eventMeta = {}
            eventMeta.hasBookMaker = !!mkt.metadata && !!mkt.metadata.hasBookMaker && mkt.metadata.hasBookMaker === "True" ? "true" : "false"
            eventMeta.hasSession = !!mkt.metadata && !!mkt.metadata.hasSession && mkt.metadata.hasSession === "True" ? "true" : "false"
            eventMeta.hasTv = !!mkt.metadata && !!mkt.metadata.hasTv && mkt.metadata.hasTv === "True" ? "true" : "false"
            let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz(mkt.metadata.book) : null
            if (mkt.eventType.id === "300") {
                data[i].displayMarketNameTime = dateUtil.getBinaryMarketDisplayName(mkt.catalogue.marketName)
                data[i].symbolType = !!mkt.metadata && !!mkt.metadata.symbol_type ? mkt.metadata.symbol_type : null
                data[i].eventId = mkt.event.id
                data[i].eventName = mkt.event.name
                data[i].competitionName = mkt.competition.name
            }
            // const market_end_time = !!mkt.metadata && !!mkt.metadata.market_end_time ? mkt.metadata.market_end_time : null
            data[i].metadata = {}
            data[i].metadata.book = book
            data[i].metadata.eventMeta = eventMeta
            // if(!!market_end_time){
            //     data[i].metadata.market_time = moment(mkt.catalogue.marketTime).format('HH:mm')
            //     data[i].metadata.market_end_time = moment(new Date(parseInt(market_end_time)).toLocaleString()).format("HH:mm")
            // }
        })
        return data
    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })
        
    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = ""){
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name){
        this.setState({selectedSection: this.state.selectedSection === name ? "" : name});
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        let SclMd = localStorage.getItem("SocialMedia");
        if(!!SclMd && Object.keys(SclMd).length > 0){
            SclMd = JSON.parse(SclMd);
        }
        return (
            <>
            {
              !this.state.inMaitanence?
            <div className="radheexch radheexchlogin bg-white-login">
                <header>
                    {/* <ReCAPTCHA
                        // size={"invisible"}
                        ref={recaptchaRef}
                        sitekey={ReCAPTCHA_KEY}
                    /> */}
                    <div className="container-fluid">
                        {this.state.isDev && <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV ONLINE</span>}
                        <div className="row">
                            <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                                <div className="logo">
                                    <a href=""><img src={`${BASE_IMAGE_PATH}/${oid}/uimg/${BRANDLOGOFILENAME}`} width="195" height="60px" alt="logo" /></a>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-8 col-lg-8 login-signup-header">
                                <div className="loginform">
                                    <ul className="login-wrap ">
                                        {/* <li className="user error">
                                            <input type="text" className="lowercase" tabIndex={1} autoFocus value={this.state.uid} name="uid" autoCorrect="off" autoCapitalize="off" autoComplete="off" onChange={(e) => { this.onChange(e) }} placeholder="Username" id="loginName" />
                                            <div className="che12">
                                                <label className="form-check-label" onChange={() => { this.setState({ rememberMe: !this.state.rememberMe }) }}>
                                                    <input className="form-check-input" onChange={() => { this.setState({ rememberMe: !this.state.rememberMe }) }} checked={this.state.rememberMe ? 'checked' : ''} type="checkbox" /> <span className="checkbox-text">Remember me</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <input tabIndex={2} type="Password" value={this.state.passcode} name="passcode" id="passcode" onChange={(e) => { this.onChange(e) }} onKeyUp={(e) => { this.handleKey(e) }} placeholder="password" /><span onClick={() => { this.onPasswodVisible() }} className="Passcode-visible">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                            <div className="che12">
                                                <label className="form-check-label" onChange={() => { this.setState({ rememberMe: !this.state.rememberMe }) }}>
                                                    <a href=""><span className="checkbox-text pl-0">Forgot Password</span></a>
                                                </label>
                                            </div>
                                        </li> */}
                                        <li><input id="valid" name="valid" type="hidden" value="3aea540b-3232-48aa-9448-16199cd0e3b2" /></li>
                                        <li>
                                            <a type="submit" className="btn-login" tabIndex={3} onClick={(e) => { this.showPopup("Login") }}>Login {/*<i className="fa fa-sign-in ml-1" aria-hidden="true"></i>*/}</a>
                                        </li>
                                        <li>
                                            <a type="submit" className="btn-login" tabIndex={3} onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>Join Now {/*<i className="fa fa-handshake-o ml-1" aria-hidden="true"></i>*/}</a>
                                        </li>
                                        <li id="errorMsg" className="error"></li>
                                    </ul>
                                </div>
                                <div className="maintenance d-none">
                                    <div className="maintenance-title">Our site is under maintenance</div>
                                    <div className="maintenance-text">
                                        Our website is currenty undergoing scheduled maintenance.<br />
                                        We should be back shortly. Thank you for your patience.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <header className="headermobileshow">
                    {/* <ReCAPTCHA
                        size={"invisible"}
                        ref={recaptchaRef}
                        sitekey={ReCAPTCHA_KEY}
                    /> */}
                    <div className="container-fluid">
                        {this.state.isDev && <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV ONLINE</span>}
                        <div className="row">
                            <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                                <div className="logo">
                                    <a href=""><img src={`${BASE_IMAGE_PATH}/${oid}/uimg/${BRANDLOGOFILENAME}`} width="195" height="60px" alt="logo" /></a>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-8 col-lg-8 login-signup-header">
                                <div className="loginform">
                                    <ul className="login-wrap ">
                                        {/* <li className="user error">
                                            <input type="text" className="lowercase" tabIndex={1} autoFocus value={this.state.uid} name="uid" autoCorrect="off" autoCapitalize="off" autoComplete="off" onChange={(e) => { this.onChange(e) }} placeholder="Username" id="loginName" />
                                            <div className="che12">
                                                <label className="form-check-label" onChange={() => { this.setState({ rememberMe: !this.state.rememberMe }) }}>
                                                    <input className="form-check-input" onChange={() => { this.setState({ rememberMe: !this.state.rememberMe }) }} checked={this.state.rememberMe ? 'checked' : ''} type="checkbox" /> <span className="checkbox-text">Remember me</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <input tabIndex={2} type="Password" value={this.state.passcode} name="passcode" id="passcode" onChange={(e) => { this.onChange(e) }} onKeyUp={(e) => { this.handleKey(e) }} placeholder="password" /><span onClick={() => { this.onPasswodVisible() }} className="Passcode-visible">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                            <div className="che12">
                                                <label className="form-check-label" onChange={() => { this.setState({ rememberMe: !this.state.rememberMe }) }}>
                                                    <a href=""><span className="checkbox-text pl-0">Forgot Password</span></a>
                                                </label>
                                            </div>
                                        </li> */}
                                        <li><input id="valid" name="valid" type="hidden" value="3aea540b-3232-48aa-9448-16199cd0e3b2" /></li>
                                        <li>
                                            <a type="submit" className="btn-login" tabIndex={3} onClick={(e) => { this.showPopup("Login") }}>Login {/*<i className="fa fa-sign-in ml-1" aria-hidden="true"></i>*/}</a>
                                        </li>
                                        <li>
                                            <a type="submit" className="btn-login" tabIndex={3} onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>Join Now {/*<i className="fa fa-handshake-o ml-1" aria-hidden="true"></i>*/}</a>
                                        </li>
                                        <li id="errorMsg" className="error"></li>
                                    </ul>
                                </div>
                                <div className="maintenance d-none">
                                    <div className="maintenance-title">Our site is under maintenance</div>
                                    <div className="maintenance-text">
                                        Our website is currenty undergoing scheduled maintenance.<br />
                                        We should be back shortly. Thank you for your patience.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>


                <section className="banner">
                    {this.state.inMaitanence && this.state.hasUmShow && <Maintanence hidePopup={() => { this.hidePopup() }} />}
                    <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                            <Slider {...settings}>
                                {Object.keys(this.state.operatorDesktopBanners).length > 0 && Object.keys(this.state.operatorDesktopBanners).map((key) => {
                                    return (
                                        <div className="img-slider" key={key}>
                                            <img style={{ width: "100%" }} src={this.state.operatorDesktopBanners[key]} alt={""}></img>
                                        </div>
                                    )
                                })}
                                
                                {Object.keys(this.state.desktopBanners).length > 0 && Object.keys(this.state.desktopBanners).map((key) => {
                                    return (
                                        <div className="img-slider" key={key}>
                                            <img style={{ width: "100%" }} src={this.state.desktopBanners[key]} alt={""}></img>
                                        </div>
                                    )
                                })}
                                {Object.keys(this.state.operatorDesktopBanners).length === 0 && Object.keys(this.state.desktopBanners).length === 0 &&
                                    <div className="img-slider">
                                        <img style={{ width: "100%" }} src={BASE_IMAGE_PATH + "/casino/banner/desktopdefaultbanner.jpg"} alt={""}></img>
                                    </div>
                                }

                                {/* <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner6.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner7.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner8.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner9.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner10.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner11.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner12.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner5.jpg"} alt={""}></img>
                                </div>  
                                <div className="img-slider">
                                    <img style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner1.jpg"} alt={""}></img>                               
                                </div> */}
                                {/* <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner2.jpg"} alt={""}></img>
                                </div> */}
                                {/* <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner3.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img  style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner4.jpg"} alt={""}></img>
                                </div> */}
                            </Slider>
                        </div>
                    </div>
                </section>
                <section className="banner bannermobileshow">
                        {this.state.inMaitanence && this.state.hasUmShow && <Maintanence hidePopup={() => { this.hidePopup() }} />}
                        <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                            <div className="carousel-inner">
                                <Slider {...settings}>
                                    {Object.keys(this.state.operatorMobileBanners).length > 0 && Object.keys(this.state.operatorMobileBanners).map((key) => {
                                        return (
                                            <div className="img-slider" key={key}>
                                                <img className="bannerimgmobile" style={{ width: "100%" }} src={this.state.operatorMobileBanners[key]} alt={""}></img>
                                            </div>
                                        )
                                    })}

                                    {Object.keys(this.state.mobileBanners).length > 0 && Object.keys(this.state.mobileBanners).map((key) => {
                                        return (
                                            <div className="img-slider" key={key}>
                                                <img className="bannerimgmobile" style={{ width: "100%" }} src={this.state.mobileBanners[key]} alt={""}></img>
                                            </div>
                                        )
                                    })}
                                    
                                    {Object.keys(this.state.operatorMobileBanners).length === 0 && Object.keys(this.state.mobileBanners).length === 0 &&
                                        <div className="img-slider">
                                            <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH + "/casino/banner/mobiledefaultbanner.jpg"} alt={""}></img>
                                        </div>
                                    }
                                    {/* <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner6mobile.jpg"} alt={""}></img>                                
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner7mobile.jpg"} alt={""}></img>                                
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner8mobile.jpg"} alt={""}></img>                                
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner9mobile.jpg"} alt={""}></img>                                
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner10mobile.jpg"} alt={""}></img>                                
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner11mobile.jpg"} alt={""}></img>                                
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner12mobile.jpg"} alt={""}></img>                                
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner5mobile.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner1mobile.jpg"} alt={""}></img>                                
                                </div> */}
                                    {/* <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner2mobile.jpg"} alt={""}></img>
                                </div>                                                        */}
                                    {/* <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner3mobile.jpg"} alt={""}></img>
                                </div>
                                <div className="img-slider">
                                    <img className="bannerimgmobile" style={{ width: "100%" }} src={BASE_IMAGE_PATH+"/casino/banner/Banner4mobile.jpg"} alt={""}></img>
                                </div> */}
                                </Slider>
                            </div>
                        </div>
                    </section>
                <section className='about' id='innersection'>
                {this.state.selectedSection === "" ?
                    <LoginSportsThumbnailList showPopup={(e) => { this.showPopup("Login")}} ></LoginSportsThumbnailList>
                    : this.state.selectedSection === "aboutus" ? 
                    <AboutUs></AboutUs>
                    : this.state.selectedSection === "termandconditions" ? 
                    <TermsAndConditions></TermsAndConditions>
                    : this.state.selectedSection === "privacypolicy" ? 
                    <PrivacyPolicy></PrivacyPolicy>
                    : this.state.selectedSection === "bettingrules" ? 
                    <BettingRules></BettingRules>
                    : this.state.selectedSection === "depositsandwithdrawals" && 
                    <DepositsAndWithdrawals></DepositsAndWithdrawals>
                }
                </section>

                <div className="partner_logo">
                <ul className='footer-providers__list'>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/evolution.png"} alt="Evolution"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ezugi.png"} alt="Ezugi"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/pragmatic-live.png"} alt="Pragmatic Live"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betgames.png"} alt="Betgames"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/ssg.png"} alt="Super Spade Games"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/betsoft.png"} alt="Betsoft"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/spribe.png"} alt="Spribe"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/Evoplay.png"} alt="Evoplay"/>
                        </a>
                    </li>
                    <li className='footer-providers__list-item lastli'>
                        <a className="footer-providers__list-item-link" href="#">
                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/logo-18plus.svg"} alt="+18"/>
                        </a>
                    </li>
                </ul> 
                <div className='rules'>You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you.
    You must reside in a country in which access to online gambling to its residents.</div> 
                <div>
                    <ul className='bettingrules'>
                        <li><a href='#innersection' className={this.state.selectedSection === "" && 'active'} onClick={() => this.toggleSelectedSection('')}>Home</a></li>
                        <li><a href='#innersection' className={this.state.selectedSection === "aboutus" && 'active'} onClick={() => this.toggleSelectedSection('aboutus')}>About Us</a></li>
                        <li><a href='#innersection' className={this.state.selectedSection === "termandconditions" && 'active'} onClick={() => this.toggleSelectedSection('termandconditions')}>Terms and Conditions</a></li>
                        <li><a href='#innersection' className={this.state.selectedSection === "privacypolicy" && 'active'} onClick={() => this.toggleSelectedSection('privacypolicy')}>Privacy Policy</a></li>
                        <li><a href='#innersection' className={this.state.selectedSection === "bettingrules" && 'active'} onClick={() => this.toggleSelectedSection('bettingrules')}>Betting Rules</a></li>
                        <li><a href='#innersection' className={this.state.selectedSection === "depositsandwithdrawals" && 'active'} onClick={() => this.toggleSelectedSection('depositsandwithdrawals')}>Deposits and Withdrawals Rules</a></li>
                    </ul>
                </div>
                {/* SOCIAL MEDIA ICON */}
                <div className="icon-bar">
                    <a href={SclMd?.SOCIALMEDIALINKS?.facebook} className="facebook" title="Facebook " alt="Facebook" target="_blank" rel="noreferrer"><i className="fa fa-facebook"></i></a> 
                    <a href={SclMd?.SOCIALMEDIALINKS?.twitter} className="twitter" title="Twitter " alt="Twitter " target="_blank" rel="noreferrer"><i className="fa fa-twitter"></i></a> 
                    <a href={SclMd?.SOCIALMEDIALINKS?.instagram} className="instagram" title="Instagram " alt="Instagram " target="_blank" rel="noreferrer"><i className="fa fa-instagram"></i></a> 
                    <a href={SclMd?.SOCIALMEDIALINKS?.telegram} className="telegram" title="Telegram " alt="Telegram " target="_blank" rel="noreferrer"><i className="fa fa-telegram"></i></a>
                    <a href={SclMd?.SOCIALMEDIALINKS?.youtube} className="youtube" title="Youtube " alt="Youtube " target="_blank" rel="noreferrer"><i className="fa fa-youtube"></i></a> 
                    <a href={!!SclMd && (SclMd?.SOCIALMEDIALINKS?.whatsapp?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsapp?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsapp)} target="_blank" rel="noreferrer" className="whatsapp" title="Whatsapp Chat - Available 24x7" alt="Whatsapp Chat"><i className="fa fa-whatsapp"></i></a> 
                </div>
                </div>

            

                {/* {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />} */}
                {this.state.showPopup && <Joinnowpopup hidePopup={() => { this.hidePopup() }} showSweetAlert={(options) =>this.props.showSweetAlert(options)}  notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} toggleSelectedSection={(name)=>{ this.toggleSelectedSection(name) }} affCode={this.state.affCode}/>}
                {this.state.showLoginPopup && <Loginpopup hidePopup={() => { this.hidePopup("Login") }} showSweetAlert={(options) =>this.props.showSweetAlert(options)} history={this.props.history} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)}/>}
                {/* <a className="whats-app" href="https://api.whatsapp.com/send/?phone=%2B+447520606059 &amp;text&amp;app_absent=0" target="_blank" rel="noreferrer">
                        <img src={BASE_IMAGE_PATH + "/casino/banner/images/whatsapp-icon.png"} title="Whatsapp Chat - Available 24x7" alt="Whatsapp Chat"/>
                    </a> */}
                {/* <div className="partner_logo partnermobileshow">
                    <div className="container" style={{ "textAlign": "center", "padding": "2px", "fontSize": "12px", "color": "#fff" }}>
                        <div>
                            <a href="https://t.me/radheexch" target="_blank" rel="noopener noreferrer" className="telegramsicon" style={{ "color": "#fff" }}><img className="pr-1" src={BASE_IMAGE_PATH + "/casino/banner/images/telegram-icon.png"} alt={""}></img>Connect us on Telegram</a>
                        </div>
                    </div>

                </div> */}

            </div>
            :
            <UnderMaintenance inMaitanenceMessage={this.state.inMaitanenceMessage} />
            }
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Auth);